import React, { useState } from "react";

interface EtapasPostulacionChipProps {
  applicationId: string;
  stageStatus?: string | null;
  completedStages?: number | null;
  totalStages?: number | null;
}

type ResendState = "idle" | "sending" | "sent" | "error";

/**
 * Postulación por etapas: chip "Parcial 1/2" y acción para reenviar el enlace de
 * WhatsApp (reemplaza la invitación vigente y envía de inmediato).
 */
const EtapasPostulacionChip = ({ applicationId, stageStatus, completedStages, totalStages }: EtapasPostulacionChipProps) => {
  const [state, setState] = useState<ResendState>("idle");

  if (stageStatus !== "PARCIAL") return null;

  const resend = async (event: React.MouseEvent) => {
    event.stopPropagation();
    const baseUrl = process.env.REACT_APP_API_APPLICANT;
    if (!baseUrl || state === "sending") return;
    setState("sending");
    try {
      const userId = sessionStorage.getItem("usuarioId") ?? "";
      const res = await fetch(`${baseUrl}/application/resend-stage-link/${encodeURIComponent(applicationId)}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId }),
      });
      setState(res.ok ? "sent" : "error");
    } catch {
      setState("error");
    }
  };

  const label = state === "sending" ? "Enviando…" : state === "sent" ? "Enlace enviado" : state === "error" ? "Reintentar" : "Reenviar enlace";

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", marginLeft: "8px", verticalAlign: "middle" }}>
      <span
        title="Postulación por etapas: falta completar los datos del siguiente paso"
        style={{
          padding: "2px 8px",
          borderRadius: "999px",
          background: "#fef3c7",
          color: "#92400e",
          fontFamily: "Roboto, sans-serif",
          fontSize: "11px",
          fontWeight: 600,
          whiteSpace: "nowrap",
        }}
      >
        Parcial {completedStages ?? 1}/{totalStages ?? 2}
      </span>
      <button
        type="button"
        onClick={(event) => void resend(event)}
        disabled={state === "sending" || state === "sent"}
        title="Reenviar por WhatsApp el enlace para completar la postulación"
        style={{
          padding: "1px 8px",
          borderRadius: "6px",
          border: "1px solid #cbd5e1",
          background: "#fff",
          color: state === "error" ? "#b91c1c" : "#0050b3",
          fontFamily: "Roboto, sans-serif",
          fontSize: "11px",
          cursor: state === "sending" || state === "sent" ? "default" : "pointer",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </button>
    </span>
  );
};

export default EtapasPostulacionChip;
